/**
 * 前端数据加密工具
 *
 * [安全改进] 对敏感数据（如手机号）进行前端加密后再传输
 *
 * 使用 DES 加密算法（CBC 模式），与后端 SecretClass.cs 保持一致
 * 密钥：lqjt0578（与后端一致）
 */

import CryptoJS from 'crypto-js';

const crypto = {
  // DES 加密密钥（与后端 Common\Static\SecretClass.cs 中的 _QueryStringKey 一致）
  DES_KEY: 'lqjt0578',

  /**
   * DES 加密（与后端 SecretClass.Encrypt 方法一致）
   * 使用 CBC 模式，与 C# DESCryptoServiceProvider 默认模式一致
   * @param {string} data - 要加密的明文
   * @returns {string} 加密后的十六进制字符串
   */
  encrypt(data) {
    const key = CryptoJS.enc.Utf8.parse(this.DES_KEY);
    const iv = CryptoJS.enc.Utf8.parse(this.DES_KEY);

    const encrypted = CryptoJS.DES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,  // 与后端一致使用 CBC 模式
      padding: CryptoJS.pad.Pkcs7
    });

    // 转换为十六进制字符串（与后端格式一致）
    return encrypted.ciphertext.toString().toUpperCase();
  },

  /**
   * DES 解密（与后端 SecretClass.Decrypt 方法一致）
   * @param {string} encryptedData - 十六进制加密字符串
   * @returns {string} 解密后的明文
   */
  decrypt(encryptedData) {
    const key = CryptoJS.enc.Utf8.parse(this.DES_KEY);
    const iv = CryptoJS.enc.Utf8.parse(this.DES_KEY);

    const encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedData);
    const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);

    const decrypted = CryptoJS.DES.decrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,  // 与后端一致使用 CBC 模式
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  },

  /**
   * 加密手机号
   * @param {string} phone - 手机号
   * @returns {string} 加密后的手机号
   */
  encryptPhone(phone) {
    return this.encrypt(phone);
  },

  /**
   * 解密手机号（用于调试，生产环境不应在前端解密）
   * @param {string} encryptedPhone - 加密的手机号
   * @returns {string} 解密后的手机号
   */
  decryptPhone(encryptedPhone) {
    return this.decrypt(encryptedPhone);
  }
};

export default crypto;
